import { render, staticRenderFns } from "./SettingPreviewArea.vue?vue&type=template&id=2a6a4a72&scoped=true"
import script from "./SettingPreviewArea.vue?vue&type=script&lang=js"
export * from "./SettingPreviewArea.vue?vue&type=script&lang=js"
import style0 from "./SettingPreviewArea.vue?vue&type=style&index=0&id=2a6a4a72&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a6a4a72",
  null
  
)

export default component.exports